import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { IRatingOption } from './rating.model';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatIconButton,
        MatTooltip,
        MatIcon,
    ]
})
export class RatingComponent {
  readonly value = model<number | undefined>(undefined);
  readonly stars = input<IRatingOption[]>([]);
  readonly color = input<'primary' | 'accent' | 'warn' | undefined>(undefined);
  readonly disabled = input<boolean>(true);
  readonly ratingUpdated = output<IRatingOption>();

  constructor() {}

  onClick(rating: IRatingOption) {
    if (this.disabled()) return;
    this.value.set(rating.value);
    this.ratingUpdated.emit(rating);
  }

  getIcon(value: any) {
    if ((this.value() ?? 0) >= value) {
      return 'star';
    } else {
      return 'star_border';
    }
  }
}
